const subsectionBodyContainerStyle = {
  container: {
    width: '100%',
    borderRadius: 1,
    px: 1.5,
    py: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    overflow: 'auto',
    maxHeight: 'calc(100vh - 250px)',

  },
};

export default subsectionBodyContainerStyle;
